// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uns1","importantInfo":"styles_importantInfo__3fnZ6"};